import React from 'react'

import { SplacePageContainer, StyledLogo } from '@lara/components'

export const SplashPage: React.FunctionComponent = () => {
  return (
    <SplacePageContainer>
      <StyledLogo width="250px" />
    </SplacePageContainer>
  )
}
